<template lang="html">
  <span class="filterbar_input" :title="hint">
    {{ name }}:

    <span class="filter_input_combo">
      <input
        ref="input"
        class="wm_search_input "
        type="text"
        :placeholder="$txt.type_to_filter"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        @focus="open_dropdown()"
        @click="open_dropdown()"
        @blur="close_dropdown()"
        @keydown.esc="open = false"
        :style="{ width: '150px' }"
      />

      <ul v-if="open && has_options" class="filter_input_options">
        <li
          v-for="opt in filtered_options"
          :key="opt"
          class="filter_input_option"
          :class="{ selected: opt === modelValue }"
          @mousedown.prevent="select_option(opt)"
        >
          {{ opt }}
        </li>
        <li
          v-if="filtered_options.length === 0"
          class="filter_input_option filter_input_option_empty"
        >
          -
        </li>
      </ul>
    </span>

    <IconBtn
      :class="{ invisible: modelValue.length === 0 }"
      @clicked="$emit('update:modelValue', '')"
      :icon="$icon.clear_search"
    />
  </span>
</template>

<script>
export default {
  props: {
    modelValue: String,
    name: String,
    placeholder: String,
    disabled: Boolean,
    hint: String,
    // Optional list of strings. When provided, the input becomes a
    // combobox: clicking shows all options, typing filters them.
    options: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      open: false
    };
  },

  computed: {
    has_options() {
      return Array.isArray(this.options) && this.options.length > 0;
    },

    filtered_options() {
      if (!this.has_options) return [];
      let pattern = (this.modelValue || "").trim().toLowerCase();
      if (pattern === "") return this.options;
      return this.options.filter(opt =>
        String(opt)
          .toLowerCase()
          .includes(pattern)
      );
    }
  },

  methods: {
    open_dropdown() {
      if (this.has_options) this.open = true;
    },
    close_dropdown() {
      // mousedown.prevent on options/caret keeps focus, so blur here
      // only fires on genuine focus loss (clicking outside).
      this.open = false;
    },
    select_option(opt) {
      this.$emit("update:modelValue", opt);
      this.open = false;
    }
  }
};
</script>

<style lang="css" scoped>
.filter_input_combo {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.filter_input_options {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  margin: 2px 0 0 4px;
  padding: 0;
  list-style: none;
  min-width: 158px;
  max-height: 240px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.filter_input_option {
  padding: 5px 10px;
  font-size: 14px;
  color: black;
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
}

.filter_input_option:hover {
  background-color: #e8f0fe;
}

.filter_input_option.selected {
  background-color: #d5e5ff;
}

.filter_input_option_empty {
  color: #999;
  cursor: default;
}
</style>
